import { routerErrror } from '../route-navigation'

function exchangeGCode(item) {
  this.tab = 'exchange'
  this.$router
    .push({
      name: 'GiftcodeDetail',
      params: {
        id: this.$route.params.id,
      },
      query: {
        evid: item.id,
        tab: 'doi-code',
      },
    })
    .catch(routerErrror)
  this.received = false
  this.viewGCodePopup = false

  if (!this.isAuthenticated) {
    this.$store.state.status.login_required = true
  } else {
    if (item.type === 'normal') {
      this.$store.commit('updateCode', item.code)
    } else {
      if (this.giftcode_show.length !== 0) {
        this.$store.commit('updateCode', this.giftcode_show.code)
      }
    }
  }
}

function joinEvent() {
  window.open(
    this.giftcode_detail.facebook_post_url ||
      this.giftcode_show.facebook_post_url
  )
}

function alertErrorCode() {
  window.open(window.localStorage.getItem('message_url'))
}

function homePage(item) {
  window.open(item.homepage)
}

function goFanpage(item) {
  window.open(item.page_url)
}

function downloadGame(item) {
  window.open(item.download_url, '_blank')
}

function goBack() {
  this.$router.push('/').catch(routerErrror)
}

function support() {
  if (!this.isAuthenticated) {
    this.overlay = false
    this.activeClass = true
    this.$router.push('/login').catch(routerErrror)
  } else {
    this.overlay = !this.overlay
    this.activeClass = false
  }
}

function exchangeCode() {
  if (!this.isAuthenticated) {
    this.$store.state.status.login_required = true
    this.$store.commit(
      'MESSAGE_ERROR',
      'Vui lòng đăng nhập để truy cập trang web!',
      { root: true }
    )
  }
  if (!this.$route.params.id) {
    this.$router
      .push({
        path: 'giftcode',
        query: {
          tab: 'doi-code',
        },
      })
      .catch(routerErrror)
  } else {
    this.$router
      .push({
        path: `/giftcode/${this.$route.params.id}`,
        query: {
          tab: 'doi-code',
        },
        replace: true,
      })
      .catch(routerErrror)
  }
}

function clearCache() {
  window.localStorage.removeItem('save')
  window.localStorage.removeItem('server_name')
  window.localStorage.removeItem('server_group')
  window.localStorage.removeItem('server_name')
  window.localStorage.removeItem('game_server')
  window.localStorage.removeItem('server_by_group')
  window.localStorage.removeItem('character_name')
  this.$router.push('/')
}

function checkVip() {
  if (!this.isAuthenticated) {
    this.status.login_required = true
  } else {
    this.flagUserVip = true
    this.$store.dispatch('USER_VIP_REQUEST')
    this.dialogVip = true
  }
}

function checkOpen() {
  if (!this.isAuthenticated) {
    this.status.login_required = true
  } else {
    this.flagUserOpen = true
    this.$store.dispatch('USER_OPEN_REQUEST')
    this.dialogOpen = true
  }
}

function checkVxuForMonth() {
  if (!this.isAuthenticated) {
    this.status.login_required = true
  } else {
    this.flagUserVip = false
    this.$store.dispatch('USER_VXU_REQUEST')
    this.dialogVip = true
  }
}

function checkVxuOpenForMonth() {
  if (!this.isAuthenticated) {
    this.status.login_required = true
  } else {
    this.flagUserOpen = false
    this.$store.dispatch('USER_VXU_OPEN_REQUEST')
    this.dialogOpen = true
  }
}

function zaloContact(item) {
  window.open(`https://zalo.me/${item}`)
}

function topup(item) {
  window.open(`https://nap.vgplay.vn/${item}`, '_blank')
}

export {
  exchangeGCode,
  joinEvent,
  alertErrorCode,
  homePage,
  goFanpage,
  downloadGame,
  goBack,
  exchangeCode,
  support,
  clearCache,
  checkVip,
  checkOpen,
  checkVxuForMonth,
  checkVxuOpenForMonth,
  zaloContact,
  topup,
}
